import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
/**
 * The nine semantic type steps are `--text-*` theme entries in
 * `styles/tokens.css`, so Tailwind emits them as `text-micro` … `text-hero`.
 * tailwind-merge cannot tell those from `text-muted-foreground` and files them
 * under *text-colour*, which means any `cn()` that carries a size step and a
 * colour class silently drops the size — the colour wins the group.
 * Registering the names as font sizes restores the intended behaviour and
 * additionally lets a step override a built-in (`cn('text-ui', 'text-title')`
 * resolves to `text-title`).
 *
 * `packages/user/src/lib/utils.ts` re-exports this function, and the
 * typography drift gate checks that exactly these nine names are registered.
 */
const TYPE_STEPS = [
    'micro',
    'caption',
    'body',
    'ui',
    'readout',
    'title',
    'page',
    'display',
    'hero',
];
/** The two mono styles (`text-code`, `text-code-readout`): sizes, not colours. */
const MONO_STYLES = ['code', 'code-readout'];
/**
 * The density and layout entries of `styles/tokens.css` are `--spacing-*`
 * theme keys, so Tailwind emits `h-control`, `px-cell-x`, `w-sheet` and the
 * like. tailwind-merge does not know a custom spacing key, so without this a
 * consumer's `h-8` would not replace a primitive's `h-control` and both would
 * stay in the class list, the primitive's winning by stylesheet order.
 */
const SPACING_KEYS = [
    'control',
    'control-sm',
    'row',
    'cell-x',
    'cell-y',
    'form-row',
    'table-header',
    'shell-header',
    'page-header',
    'toolbar',
    'sidebar',
    'sidebar-rail',
    'sheet',
    'sheet-lg',
    'page-padding',
];
const twMerge = extendTailwindMerge({
    extend: {
        theme: { spacing: [...SPACING_KEYS] },
        classGroups: { 'font-size': [{ text: [...TYPE_STEPS, ...MONO_STYLES] }] },
    },
});
/** Class-name joiner for the shared primitives and both applications. */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=cn.js.map